module.exports = __webpack_public_path__ + "static/SDL-85bcffa14d30e151c8bfdab7257b3909.png";